'use client';

import { useBoardEditorConfigStore } from '@/stores/useBoardEditorConfigStore';

export default function BoardEditorSidebar() {
    const isDark = useBoardEditorConfigStore((s) => s.isDark);
    return <div className={`w-8 h-full ${isDark ? 'bg-color-ide-frame-dark-bg' : 'bg-color-ide-frame-bg'}`} />;
}
